import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Paper,
} from '@mui/material';

interface AvatarSelectorProps {
  selectedAvatar: string;
  onSelect: (avatar: string) => void;
}

// Pre-selected emoji avatars
const AVATARS = [
  '😊', '😎', '🤓', '😇', '🥳',
  '🤩', '😁', '😄', '😃', '😉',
  '🙂', '😌', '💙', '💚', '💛',
  '💜', '❤️', '🧡', '🤍', '🖤',
  '🦁', '🐯', '🐻', '🐼', '🦊',
  '🐶', '🐱', '🐰', '🐨', '🐸',
  '🚀', '⚡', '💫', '⭐', '✨',
  '🎯', '🎮', '🎸', '🎨', '📚',
];

const AvatarSelector: React.FC<AvatarSelectorProps> = ({
  selectedAvatar,
  onSelect,
}) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Choose your profile avatar
      </Typography>
      <Box
        sx={{
          maxHeight: 300,
          overflowY: 'auto',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          p: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: 'flex-start',
          }}
        >
          {AVATARS.map((avatar) => (
            <Paper
              key={avatar}
              elevation={selectedAvatar === avatar ? 4 : 0}
              sx={{
                cursor: 'pointer',
                transition: 'all 0.2s',
                border: selectedAvatar === avatar ? '2px solid' : '1px solid',
                borderColor: selectedAvatar === avatar ? 'primary.main' : 'divider',
                '&:hover': {
                  transform: 'scale(1.1)',
                  boxShadow: 2,
                },
              }}
              onClick={() => onSelect(avatar)}
            >
              <Avatar
                sx={{
                  width: { xs: 40, sm: 50 },
                  height: { xs: 40, sm: 50 },
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  bgcolor: selectedAvatar === avatar ? 'primary.light' : 'background.default',
                }}
              >
                {avatar}
              </Avatar>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AvatarSelector;
